/* eslint-disable react-hooks/exhaustive-deps */
import * as yup from "yup";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import AutoComplete from "@/components/hookForms/autoComplete";
import TextInput from "@/components/hookForms/textField";
import messages from "@/utils/messages";
import { Title } from "@/components/title/style";
import IGenericResult from "@/interfaces/IGenericResult";
import { LoadingButton } from "@mui/lab";
import serviceModeloFatura from "@/services/serviceModeloFatura";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    data?: any;
    concessionariaDataOptions: IGenericResult[];
    tipoFaturaDataOptions: any;
}
const Modal: React.FC<IDialogProps> = ({
    open,
    onClose,
    concessionariaDataOptions,
    tipoFaturaDataOptions,
    data,
    onSuccess,
}) => {
    const [isDisable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const validationSchema = yup.object().shape({
        descricaoModelo: yup.string().required(messages.requiredField),
        concessionariaID: yup.number().typeError(messages.optionNotExist).required(messages.requiredField),
        tipoFatura: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            descricaoModelo: "",
            concessionariaID: "",
            tipoFatura: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);
        setLoading(true);

        const newValues = {
            ...values,
            modeloFaturaId: data.modeloFaturaId,
        };

        serviceModeloFatura
            .updateModelo(newValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    reset();
                    onClose();
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setLoading(false);
                setDisable(false);
            });
    };

    return (
        <Box>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <Title>Editar Cadastro de Modelo</Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid container>
                            <Grid item md={12} xs={12}>
                                <AutoComplete
                                    id="concessionariaID"
                                    name="concessionariaID"
                                    label="Concessionária"
                                    options={concessionariaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <TextInput
                                    id="descricaoModelo"
                                    name="descricaoModelo"
                                    label="Descrição Modelo"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <AutoComplete
                                    id="tipoFatura"
                                    name="tipoFatura"
                                    label="Tipo de Fatura"
                                    options={tipoFaturaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            onClick={() => {
                                reset();
                                onClose();
                            }}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <LoadingButton
                            type="submit"
                            color="primary"
                            variant="contained"
                            loading={isLoading}
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Salvar
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </Box>
    );
};

export default Modal;
